import { Link } from '@tanstack/react-router'
import type { CellContext } from '@tanstack/react-table'
import { FolderIcon } from 'lucide-react'

import { getFolderPath } from '@/utils'
import type { Folder } from '../../stores/types'

export const NameCell = (cell: CellContext<Folder, string>) => {
  const folder = cell.row.original as Folder

  return (
    <Link
      to={getFolderPath(folder)}
      aria-label={`Open ${cell.getValue()} folder`}
      className="flex items-center gap-2.5 text-blue-7 hover:underline font-semibold text-[15px] h-full py-3"
    >
      <FolderIcon className="size-4.5 text-blue-6" />
      <span>{cell.getValue()}</span>
    </Link>
  )
}
